import { render, staticRenderFns } from "./StaffAssignDialogWithModal.vue?vue&type=template&id=6152b69f&scoped=true"
import script from "./StaffAssignDialogWithModal.vue?vue&type=script&lang=js"
export * from "./StaffAssignDialogWithModal.vue?vue&type=script&lang=js"
import style0 from "./StaffAssignDialogWithModal.vue?vue&type=style&index=0&id=6152b69f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152b69f",
  null
  
)

export default component.exports